import { render, staticRenderFns } from "./PromoStatusBadge.vue?vue&type=template&id=2474ba2c&"
import script from "./PromoStatusBadge.vue?vue&type=script&lang=js&"
export * from "./PromoStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports